import AOS from 'aos';
import {
  maskDigitsOnly, validateFilePondRequired, validateForms,
} from '../../service/validate';
import dropdownCloseFix from '../../service/listner/dropdown';
import initAuthMenu from '../../lib/authMenu';
import replaceInputFile from '../../service/replace/filepond';
import { listenScrollTo } from '../../service/listner/tab';
import { browserBack } from '../../service/listner/popstate';
import { headerOffset } from '../../service/observer';
import { listenAccordion } from '../../service/listner/accordion';

export default async function ICommon() {
  headerOffset();
  AOS.init();
  maskDigitsOnly();
  validateForms();
  dropdownCloseFix();
  initAuthMenu();
  listenAccordion('[data-accordion]');

  listenScrollTo();
  browserBack();

  const files = document.querySelectorAll('input[type="file"]');
  [...files].forEach((file) => {
    const filepond = replaceInputFile(file);
    validateFilePondRequired(document.querySelector('#modalSearchByPhoto form'), filepond);
  });

  // todo:пока закоментировал, так как скрыл города в вёрстке.
  // searchPlace();
}
